export default __webpack_public_path__ + "static/media/banner3_colombia.2afdeead.png";